export default __webpack_public_path__ + "static/media/tuatj.67d52eaf.png";